// extracted by mini-css-extract-plugin
export var button = "_jd-2";
export var card = "_jd-0";
export var closeButtonContainer = "_jd-3";
export var iconContainer = "_jd-1";